import { useQuery } from "@apollo/client";
import propertyInformationByUPRN from "./propertyInformationByUPRN.gql";
import { routedClient } from "react-migration/lib/persistence/apollo/routedClient";
import { EpcEnergyRating } from "../../UKPropertyInformationSelectionSidebar/useProperties";

interface Valuation {
  ba_name?: string;
  primary_description: number;
  total_value: number;
  total_area: number;
  list_year: number;
  ppsqm: number;
}

interface PropertyInformation {
  address: {
    uprn: string;
    full_address?: string;
    use_class_description_2020?: string;
    property_class_description?: string;
    property_class_code?: string;
    state?: string;
    location: {
      coordinates: [number, number];
    };
    voa_record?: {
      uarn: string;
      valuations?: Valuation[];
    };
  };

  dimensions?: {
    area_floor_total_metric?: number;
  };

  building_height?: {
    uprn?: string;
    rel_h_max?: number;
    rel_h_to_roof?: number;
    no_floors_estimate?: number;
  };
  epc: {
    appraisal_date: number;
    current_energy_rating: EpcEnergyRating;
    current_energy_efficiency: number;
    potential_energy_rating: EpcEnergyRating;
    potential_energy_efficiency: number;

    property_type: string;
    built_form: string;
    total_floor_area: number;
    tenure: string;
    number_habitable_rooms: number;
    roof_type: string;
    construction_age_band: string;
  };
}

export function usePropertyInformationByUPRN(uprn?: string) {
  return useQuery<{ propertyInformationByUPRN: PropertyInformation }>(propertyInformationByUPRN, {
    variables: { uprn: uprn! },
    skip: !uprn,
    client: routedClient,
  });
}
